import { combineReducers } from 'redux'
import dashboardReducer from '../pages/Dashboard/store/dashboard.reducer'
import authReducer from '../pages/Auth/store/auth.reducer'
import utilisateurReducer from '../pages/Utilisateur/store/utilisateur.reducer'
import domaineReducer from '../pages/Domaine/store/domaine.reducer'
import messageReducer from '../pages/Messages/store/message.reducer'

const appReducer = combineReducers({
    dashboard: dashboardReducer,
    auth: authReducer,
    utilisateur: utilisateurReducer,
    messages:messageReducer,
    domaine: domaineReducer,
})

export type AppState = ReturnType<typeof appReducer>

export default appReducer
